import { UncontrolledCollapse, CardBody, Card } from 'reactstrap';
import { Trans, useTranslation } from "gatsby-plugin-react-i18next";

const Partners = () => {
    const { t } = useTranslation();
    return (
    <>
        <section className="bg-dark hero-bg position-relative phw1">
            <div className="container custom_container d-flex justify-content-center align-items-center p0 m-d-block text-center">
                <div className="col-12 partner-hero-title">
                    <div className='position-absolute w-100 pt-5'>
                        <h1 className="font-weight-semibold hero-heading no-br text-center">
                            <Trans>Unlock the Best with our <br/>Dynamic Network of Partners</Trans>
                        </h1>
                        <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a href={t(`/partnership/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Let's Talk</Trans>
                            </a>
                        </div>
                    </div>

                    <div className='text-center partner-hero-image'>
                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/e_trim/v1714737214/VantageFit/2023/partners_1.webp" alt="Partners image" width="1268" height="733"/>
                    </div>

                </div>
            </div>
        </section>

        <section className="position-relative pl-0 pr-0 about-pattern-vfit">
            <div className="">
                <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                        <Trans>Taking the hassle out of wellness</Trans>
                    </h2>
                    <div className="container custom_container home-bg-2 brd22 mb-5 partners-box">
                        <div className="col-12 section-collapsible">
                            <div id="toggler1" className="section-collapsible-title row m-d-block">
                                <div className="col-12">
                                    <div className="collapsible-content">
                                        <h3 className='red-font'><Trans>Physical Wellness</Trans></h3>
                                        <p className="section-para mb-0"><Trans>Your employees deserve the best. Invest in their physical wellness today<br/> and reap the rewards.</Trans></p>
                                    </div>
                                </div>
                            </div>
                            <UncontrolledCollapse toggler="#toggler1">
                                <Card>
                                    <CardBody className="d-flex justify-content-around justify-content-md-start flex-wrap align-items-center pt-0">
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551623/VantageFit/2023/partner-logos/Healthifyme.webp"
                                            alt="VantageFit Partnership Physical Wellness"
                                            width=""
                                            height="36px"
                                            loading="lazy" />
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551622/VantageFit/2023/partner-logos/Fitmate.webp"
                                            alt="VantageFit Partnership Physical Wellness"
                                            width=""
                                            height="36px"
                                            loading="lazy" />
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551622/VantageFit/2023/partner-logos/Fitterfly.webp"
                                            alt="VantageFit Partnership Physical Wellness"
                                            width=""
                                            height="36px"
                                            loading="lazy" />
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551625/VantageFit/2023/partner-logos/Karkinos.webp"
                                            alt="VantageFit Partnership Physical Wellness"
                                            width=""
                                            height="36px"
                                            loading="lazy" />
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551626/VantageFit/2023/partner-logos/Medibuddy.webp"
                                            alt="VantageFit Partnership Physical Wellness"
                                            width=""
                                            height="36px"
                                            loading="lazy" />
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551624/VantageFit/2023/partner-logos/Indushealth.webp"
                                            alt="VantageFit Partnership Physical Wellness"
                                            width=""
                                            height="36px"
                                            loading="lazy" />
                                    </CardBody>
                                </Card>
                            </UncontrolledCollapse>
                        </div>
                    </div>

                    <div className="container custom_container home-bg-2 brd22 mb-5 partners-box">
                        <div className="col-12 section-collapsible">
                            <div id="toggler2" className="section-collapsible-title row m-d-block">
                                <div className="col-12">
                                    <div className="collapsible-content">
                                        <h3 className='green-font'><Trans>Mental Wellness</Trans></h3>
                                        <p className="section-para mb-0"><Trans>Let your employees say goodbye to burnout and hello to productivity.</Trans></p>
                                    </div>
                                </div>
                            </div>
                            <UncontrolledCollapse toggler="#toggler2">
                                <Card>
                                    <CardBody className="d-flex justify-content-around justify-content-md-start flex-wrap align-items-center pt-0">
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551622/VantageFit/2023/partner-logos/Bundle.webp"
                                            alt="VantageFit Partnership Mental Wellness"
                                            width=""
                                            height="36"
                                            loading="lazy" />
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551621/VantageFit/2023/partner-logos/breathe_hub.webp"
                                            alt="VantageFit Partnership Mental Wellness"
                                            width=""
                                            height="36"
                                            loading="lazy" />
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551625/VantageFit/2023/partner-logos/ManoShala.webp"
                                            alt="VantageFit Partnership Mental Wellness"
                                            width=""
                                            height="36"
                                            loading="lazy" />
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551626/VantageFit/2023/partner-logos/Mantra_care.webp"
                                            alt="VantageFit Partnership Mental Wellness"
                                            width=""
                                            height="36"
                                            loading="lazy" />
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551623/VantageFit/2023/partner-logos/Heyy.webp"
                                            alt="VantageFit Partnership Mental Wellness"
                                            width=""
                                            height="36"
                                            loading="lazy" />
                                    </CardBody>
                                </Card>
                            </UncontrolledCollapse>
                        </div>
                    </div>
                    <div className="container custom_container home-bg-2 brd22 mb-5 partners-box">
                        <div className="col-12 section-collapsible">
                            <div id="toggler3" className="section-collapsible-title row m-d-block">
                                <div className="col-12">
                                    <div className="collapsible-content">
                                        <h3 className='orange-font'><Trans>Financial Wellness</Trans></h3>
                                        <p className="section-para mb-0"><Trans>Invest in your employees' financial well-being & wave goodbye to financial woes.</Trans></p>
                                    </div>
                                </div>
                            </div>
                            <UncontrolledCollapse toggler="#toggler3">
                                <Card>
                                    <CardBody className="d-flex justify-content-around justify-content-md-start flex-wrap align-items-center pt-0">
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551621/VantageFit/2023/partner-logos/acru.webp"
                                            alt="VantageFit Partnership Financial Wellness"
                                            width=""
                                            height="36"
                                            loading="lazy" />
                                    </CardBody>
                                </Card>
                            </UncontrolledCollapse>
                        </div>
                    </div>
                    <div className="container custom_container home-bg-2 brd22 mb-5 partners-box">
                        <div className="col-12 section-collapsible">
                            <div id="toggler4" className="section-collapsible-title row m-d-block">
                                <div className="col-12">
                                    <div className="collapsible-content">
                                        <h3 className='light-purple-font'><Trans>Habit building</Trans></h3>
                                        <p className="section-para mb-0"><Trans>Redefine your employees' life and drive positive change with the power of habit building.</Trans></p>
                                    </div>
                                </div>
                            </div>
                            <UncontrolledCollapse toggler="#toggler4">
                                <Card>
                                    <CardBody className="d-flex justify-content-around justify-content-md-start flex-wrap align-items-center pt-0">
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551627/VantageFit/2023/partner-logos/quitsure.webp"
                                            alt="VantageFit Partnership Habit Building"
                                            width=""
                                            height="36"
                                            loading="lazy" />
                                        <img className="img-responsive" src="https://res.cloudinary.com/vantagecircle/image/upload/v1709551628/VantageFit/2023/partner-logos/wellness_seekers.webp"
                                            alt="VantageFit Partnership Habit Building"
                                            width=""
                                            height="36"
                                            loading="lazy" />
                                    </CardBody>
                                </Card>
                            </UncontrolledCollapse>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
            <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                <div className="col-12">
                    <h2 className="font-weight-semibold section-heading text-center no-br">
                        <Trans>Unlock the Power of Partnerships for <br/>your Employee Wellness Program!</Trans>
                    </h2>
                    <div className='row bottom-cont'>
                        <div className='col-12 col-sm-6 section-para font-weight-normal greenTick'>
                            <ul>
                                <li className='text-white'><Trans>Boost employee engagement and productivity.</Trans></li>
                                <li className='text-white'><Trans>Build an inclusive, health-conscious community.</Trans></li></ul>
                        </div>
                        <div className='col-12 col-sm-6 section-para font-weight-normal greenTick'>
                            <ul>
                                <li className='text-white'><Trans>Pursue emerging wellness market opportunities.</Trans></li>
                                <li className='text-white'><Trans>Develop branding that conveys well-being commitment.</Trans></li></ul>
                        </div>
                    </div>
                    <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                        <a href={t(`/partnership/`)} className="vfitcompanycta arrowbtn-img">
                            <Trans>Partner with us</Trans>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Partners
